<template>
    <fragment>
        <!-- 如果有children 就循环递归展示 -->
        <el-submenu
                v-if="menu.children"
                :index="menu.id + ''"
                :key="menu.id">
            <template slot="title">
                <i :class="menu.icon"></i>
                <span slot="title" v-text="menu.menuName"></span>
            </template>
            <!-- 递归有子孙导航组件 -->
            <side-bar-item
                    v-for="children in menu.children"
                    :key="children.id"
                    :menu="children" >
            </side-bar-item>
        </el-submenu>

        <!-- 无子孙导航 -->
        <el-menu-item v-else :key="menu.id" :index="menu.path">
            <i :class="menu.icon"></i>
            <span slot="title" v-text="menu.menuName"></span>
        </el-menu-item>
    </fragment>
</template>

<script>
    export default {
        name: "SideBarItem",
        data() {
            return {
            }
        },
        props: ['menu']
    }
</script>

<style scoped>
    .el-submenu__title i, .el-menu-item i {
        color: inherit;
    }
    .el-menu-item:hover, .el-submenu >>> .el-submenu__title:hover{
        background-color: #263445!important;
    }
    .el-submenu >>> .el-menu-item, .el-submenu >>> .el-menu > .el-submenu > .el-submenu__title {
        background-color: #1f2d3d !important;
    }
    .el-submenu >>> .el-menu-item:hover,
    .el-submenu >>> .el-menu > .el-submenu > .el-submenu__title:hover {
        background-color: #001528 !important;
    }
</style>
